// extracted by mini-css-extract-plugin
export var actionText = "_mr-4";
export var container = "_mr-0";
export var leftSection = "_mr-1";
export var rightSection = "_mr-2";
export var settingsButton = "_mr-6";
export var settingsIcon = "_mr-7";
export var shortcut = "_mr-5";
export var shortcutGroup = "_mr-3";